var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.option.mask || null),expression:"option.mask || null"}],staticClass:"primary--text",attrs:{"hide-details":"auto","label":_vm.option.name,"loading":_vm.loading,"value":_vm.selectedOptions,"rules":_vm.option.rules || null},on:{"change":_vm.updated}})
}
var staticRenderFns = []

export { render, staticRenderFns }